import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  IconButton,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  InputAdornment,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import {
  AccountCircle,
  Email,
  Lock,
  LocationOn,
  Phone,
} from "@mui/icons-material";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Fade from "@mui/material/Fade";
import Title from "../Title/Title";

const apiUrl = "https://projectarthabackend.ajinkyatechnologies.com/api/category";

const CategoryManagement = () => {
  const [data, setData] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openDialog, setOpenDialog] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
  });
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedItemToDelete, setSelectedItemToDelete] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await axios.post(`${apiUrl}/get-categories`);
      setData(response.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const handleAddItem = () => {
    setSelectedItemId(null);
    setOpenDialog(true);
    // Reset form fields
    setFormData({
      name: "",
      description: "",
    });
  };

  const handleEditItem = async (itemId) => {
    setSelectedItemId(itemId);
    setOpenDialog(true);
    try {
      const response = await axios.post(`${apiUrl}/categories/${itemId}`);
      setFormData(response.data);
    } catch (error) {
      console.error("Error fetching item:", error);
    }
  };

  const handleCloseDialog = () => {
    setSelectedItemId(null);
    setOpenDialog(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDeleteItem = (itemId) => {
    setSelectedItemToDelete(itemId);
    setOpenDeleteDialog(true);
  };

  const confirmDeleteItem = async () => {
    try {
      await axios.delete(`${apiUrl}/categories/${selectedItemToDelete}`);
      fetchData();
      toast.success("Item deleted successfully");
    } catch (error) {
      console.error("Error deleting item:", error);
      toast.error("Error deleting item");
    }
    setOpenDeleteDialog(false);
  };

  const handleFormChange = (e, fieldName) => {
    const value = e.target.value;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [fieldName]: value,
    }));
  };

  const handleAddItemSubmit = async () => {
    try {
      let endpoint = `${apiUrl}/categories`;
      let method = "POST";
      let successMessage = "";

      if (selectedItemId) {
        endpoint = `${apiUrl}/categories/${selectedItemId}`;
        method = "PUT";
        successMessage = "Item updated successfully";
      } else {
        successMessage = "Item added successfully";
      }

      const response = await axios({
        method: method,
        url: endpoint,
        data: formData,
      });

      if (response.status === 201 || response.status === 200) {
        fetchData();
        setOpenDialog(false);
        toast.success(successMessage);
      } else {
        toast.error("Error adding or updating item");
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Error adding or updating item");
    }
  };

  const handleSearch = async () => {
    try {
      const response = await axios.get(
        `https://projectarthabackend.ajinkyatechnologies.com/api/search/search?query=${searchTerm}`
      );
      setData(response.data.category);
    } catch (error) {
      console.error("Error searching media", error);
      // setError("Error searching media. Please try again.");
    }
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Title title={"Category Management"} className="mx-24"></Title>
      </div>
      <div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "end",
            alignItems: "center",
            marginTop: "20px",
            marginBottom: "20px",
            width: "95%",
          }}
        >
          <div className="flex items-center">
            <input
              type="text"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search Category"
              className="mr-2 px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
            />
            <button
              onClick={handleSearch}
              className="px-4 py-2 mx-4 font-medium text-white bg-blue-600 rounded-md hover:bg-blue-500 focus:outline-none focus:bg-blue-500"
            >
              Search
            </button>
          </div>
          <Button
            variant="contained"
            color="primary"
            // style={{ position: "absolute", top: 80, right: 10 }}
            startIcon={<AddIcon />}
            onClick={handleAddItem}
          >
            Add category
          </Button>
        </div>

        <div className="flex justify-center">
          <TableContainer component={Paper} style={{ width: "90%" }}>
            <Table style={{ minWidth: 650 }} aria-label="data table">
              <TableHead>
                <TableRow
                  style={{
                    background:
                      "linear-gradient(90deg, #4F46E5 0%, #7A5CEB 100%)",
                  }}
                >
                  <TableCell className="px-4 py-2" style={{ color: "white" }}>
                    Name
                  </TableCell>
                  <TableCell className="px-4 py-2" style={{ color: "white" }}>
                    Description
                  </TableCell>
                  <TableCell className="px-4 py-2" style={{ color: "white" }}>
                    Action
                  </TableCell>
                </TableRow>
              </TableHead>
              <Fade in={data} timeout={500}>
                <TableBody>
                  {data.length === 0 ? (
                    <TableRow style={{ height: "200px" }}>
                      <TableCell colSpan={3} align="center">
                        <h1 style={{ fontSize: "25px" }}>No Data Found</h1>
                      </TableCell>
                    </TableRow>
                  ) : (
                    data
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((item) => (
                        <TableRow key={item.id}>
                          <TableCell>{item.name}</TableCell>
                          <TableCell>{item.description}</TableCell>
                          <TableCell>
                            <Button
                              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
                              onClick={() => handleEditItem(item.category_id)}
                            >
                              Edit
                            </Button>
                            <IconButton
                              aria-label="delete"
                              color="black"
                              onClick={() => handleDeleteItem(item.category_id)}
                            >
                              <DeleteIcon className="text-black" />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))
                  )}
                </TableBody>
              </Fade>
            </Table>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </TableContainer>
        </div>
        <Dialog open={openDialog} onClose={handleCloseDialog}>
          <DialogTitle>
            {selectedItemId ? "Update Item" : "Add Item"}
          </DialogTitle>
          <DialogContent>
            <TextField
              label="Name"
              variant="outlined"
              fullWidth
              value={formData.name}
              onChange={(e) => handleFormChange(e, "name")}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AccountCircle color="primary" />
                  </InputAdornment>
                ),
              }}
              style={{ marginBottom: 20, marginTop: 20 }}
            />
            <TextField
              label="Description"
              variant="outlined"
              fullWidth
              value={formData.description}
              onChange={(e) => handleFormChange(e, "description")}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email color="primary" />
                  </InputAdornment>
                ),
              }}
              style={{ marginBottom: 20 }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              Cancel
            </Button>
            <Button onClick={handleAddItemSubmit} color="primary">
              {selectedItemId ? "Update" : "Add"}
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={openDeleteDialog}
          onClose={() => setOpenDeleteDialog(false)}
        >
          <DialogTitle>Delete Item</DialogTitle>
          <DialogContent>
            <p>Are you sure you want to delete this item?</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenDeleteDialog(false)} color="primary">
              Cancel
            </Button>
            <Button onClick={confirmDeleteItem} color="primary">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default CategoryManagement;
